import { FC } from 'react';
import React from 'react';
import styles from './Blanket.module.scss';

interface Props {
    onClick: () => void;
}

export const Blanket: FC<Props> = ({ onClick }) => (
    <div className={styles.blanket} onClick={onClick} />
);
